export const adminConstants = {
  ADMIN_LOAD_COMPANY_DATA_REQUEST: 'ADMIN_LOAD_COMPANY_DATA_REQUEST',
  ADMIN_LOAD_COMPANY_DATA_SUCCESS: 'ADMIN_LOAD_COMPANY_DATA_SUCCESS',
  ADMIN_LOAD_COMPANY_DATA_FAILURE: 'ADMIN_LOAD_COMPANY_DATA_FAILURE',

  ADMIN_SWITCH_COMPANY_SUCCESS: 'ADMIN_SWITCH_COMPANY_SUCCESS',
  ADMIN_SWITCH_COMPANY_FAILURE: 'ADMIN_SWITCH_COMPANY_FAILURE',
};
